import { BiFilter } from 'react-icons/bi'
import { Icon, IconProps, forwardRef } from '@chakra-ui/react'

export const OmFilter = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} {...props} as={BiFilter} />
))
